// extracted by mini-css-extract-plugin
module.exports = {"o-activity-log-list":"ActivityLogList_o-activity-log-list__IYI01","o-activity-log-list--small":"ActivityLogList_o-activity-log-list--small___Uxlp"};